import Modal from '@src/common/Modal';
import React, { useState,useEffect } from 'react';
import secureStorage from "@src/config/encrypt";
import { sendOtpToForgotPassword,verifyOtpPassword } from "@src/store/slices/user";
import FullPageLoader from '@common/FullPageLoader';
import { MAX_OTP_TIMER } from '@src/config/constant';


interface ChangePasswordModalProps {
    show: boolean;
    handleClose: () => void;
    onSuccess: (response: { show_success_popup: boolean; last_updated_pwd:string}) => void;
}

const ChangePasswordModal = ({ show, handleClose,onSuccess }: ChangePasswordModalProps) => {
    const [inputField, setInputField] = useState({
        email:"",
        password: "",
        confirm_password:"",
        otp : "",
    });
    const [errField, setErrField] = useState<any>({
        password: "",
        confirm_password:"",
        otp : "",
    });
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
    const [showVerifyOtp, setShowVerifyOtp] = useState(false);
    const [loading, setLoading] = useState(false);

    const maxTime = MAX_OTP_TIMER;
    const [otpTimer, setOtpTimer] = useState(maxTime);

    const handleClickShowPassword = (key: string) => {
        if (key === 'showNewPassword') {
            setShowNewPassword((prev) => !prev);
        } else if (key === 'showConfirmNewPassword') {
            setShowConfirmNewPassword((prev) => !prev);
        }
    };

    const validForm = () => {
        let formIsValid = true;
        setErrField({
            email: "",
            otp: "",
            password: "",
            confirm_password:"",
        });

        const password_regex = /^.{8,}$/;
        if (inputField.password === "" || inputField.password.trim() === "") {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                password: "Password is required",
            }));
        }else if (!password_regex.test(inputField.password)) {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                password: "Password should be at least 8 characters long",
            }));
        }

        if (inputField.confirm_password === "" || inputField.confirm_password.trim() === "") 
        {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                confirm_password: "Confirm password is required",
            }));
        }

        if (inputField.password !== "" && inputField.confirm_password !== "" && inputField.password !== inputField.confirm_password) 
        {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                confirm_password: "Passwords do not match",
            }));
        }
    
        if (showVerifyOtp) {
            if (inputField.otp === "" || inputField.otp.trim() === '') {
                formIsValid = false;
                setErrField((prevState: any) => ({
                    ...prevState,
                    otp: 'OTP is required',
                }));
            }
        }

        return formIsValid;
    };

    const sendOtp = () => {
        setLoading(true);
        if (validForm()) {
            let data = {
                email : inputField.email,
            }
            sendOtpToForgotPassword(data).then((res) => {
                setLoading(false)
                if (res && res.data) {
                    setShowVerifyOtp(true);
                    setOtpTimer(maxTime);
                }
                setInputField({ ...inputField, email: inputField.email})
            });
        } else {
            setLoading(false);
        }
    }

    useEffect(() => {
        let startInterval: NodeJS.Timeout;
        if (otpTimer >= 0) {

            startInterval = setInterval(() => {
                setOtpTimer((val) => val - 1)

            }, 1000)
        } else {
            setOtpTimer(-1)
        }

        return () => {
            clearInterval(startInterval)

        }
    }, [otpTimer])

    useEffect(() => {
        let result = secureStorage.getItem("authAgentUserInfo");
        if (result && result.user_data && result.user_data.email) {
            setInputField((prev) => ({
                ...prev,
                email: result.user_data.email,
            }));
        }
    } , [show])

    const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === 'otp') {
            // Allow only numeric values and restrict to 4 digits
            if (/^\d{0,4}$/.test(value)) {
                setInputField({ ...inputField, [name]: value });
            }
        } else {
            // For other fields, allow regular updates
            setInputField({ ...inputField, [name]: value });
        }
        errField[name] = '';
        setErrField({ ...errField });
    };

    const resendOtp = () => {
        if (otpTimer < 0) {
            let data = {email : inputField.email}
            sendOtpToForgotPassword(data).then((res) => {
                setLoading(false)
                if (res && res.data) {
                    //DELETE CAPTCHA HASH FROM CACHE 
                    setShowVerifyOtp(true);

                }
                setInputField({ ...inputField, email: inputField.email })
                setOtpTimer(maxTime);
            });
        }
    }

    const verifyOtp = () => {
        setLoading(true);
        if (validForm()) {
            let data = {otp : inputField.otp, password:inputField.password}
            verifyOtpPassword(data,false).then((res:any) => {
                setLoading(false)
                if (res && res.data) {
                    setInputField({
                        email: "",
                        password: "",
                        confirm_password:"",
                        otp:""
                    });
                    setShowVerifyOtp(false);
                    onSuccess({ show_success_popup: true, last_updated_pwd: res.data.last_updated_pwd});
                }else{
                    setLoading(false);
                }
            });
        } else {
            setLoading(false);
        }
    }

    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="model-outer upload-error-popup">
                <Modal show={show} handleClose={handleClose}>
                    <div className="modal-body">
                        {
                            showVerifyOtp ? 
                            (
                                <>
                                    <h2 className="otp-heading">Verify OTP</h2>
                                    <small className="otp-subheading p-sm-b">Enter the OTP sent to your registered email ID</small>
                                    <fieldset className="change-password-otp">
                                        <div className = "material">
                                            <input
                                                type="number"
                                                placeholder=" "
                                                name="otp"
                                                value={inputField.otp}
                                                className="form-input "
                                                onChange={inputHandler}
                                            />
                                            <i className="ic-otp icn-login">
                                                <i className='path1'></i>
                                                <i className='path2'></i>
                                                <i className='path3'></i>
                                                <i className='path4'></i>
                                            </i>

                                            <label data-label='Otp' className="form-label"></label>
                                            {errField.otp && (
                                                <span className="error-txt">
                                                {errField['otp'] || ""}
                                                </span>
                                            )}
                                        </div>
                                        {
                                            <span onClick={resendOtp} className={`resend-otp-txt ${otpTimer < 0 ? 'resend-otp' : ''}`}>{otpTimer < 0 ? 'Resend Otp' : 'resend otp after '+(otpTimer > 9 ? "0:" + otpTimer : "0:0" + otpTimer)+" seconds" }</span>
                                        }

                                    </fieldset>
                                </>
                            ) :
                            (
                                <>
                                    <h2>Change Password</h2>
                                    <fieldset>
                                        <div className="material">
                                            <input
                                                type={(showNewPassword)?"text":"password"}
                                                placeholder=" "
                                                name="password"
                                                value={inputField.password}
                                                className="form-input password-txt"
                                                onChange={inputHandler}
                                            />
                                            <label data-label="New Password" className="form-label"></label>
                                            <span className="password-show pwd-show-hide" onClick={() => handleClickShowPassword('showNewPassword')}><i className="ic-close_eye" ></i><i className="ic-open_eye"></i></span>
                                            {errField.password && (
                                                <span className="error-txt">
                                                    {errField['password'] || ""}
                                                </span>
                                            )}
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <div className="material">
                                            <input
                                                type={(showConfirmNewPassword)?"text":"password"}
                                                placeholder=" "
                                                name="confirm_password"
                                                value={inputField.confirm_password}
                                                className="form-input password-txt"
                                                onChange={inputHandler}
                                            />
                                            <label data-label="Confirm New Password" className="form-label"></label>
                                            <span className="password-show pwd-show-hide" onClick={() => handleClickShowPassword('showConfirmNewPassword')}><i className="ic-close_eye" ></i><i className="ic-open_eye"></i></span>
                                            {errField.confirm_password && (
                                                <span className="error-txt">
                                                    {errField['confirm_password'] || ""}
                                                </span>
                                            )}
                                        </div>
                                    </fieldset>
                                </>
                            )
                        }
                    </div>
                    
                    <div className=''>
                        {
                            showVerifyOtp ? 
                            <button className='btn-primary w-100' onClick={verifyOtp}>Verify</button>
                            :
                            <button className='btn-primary w-100' onClick={sendOtp}>Change Password</button>
                        }
                    </div>
                </Modal>
            </div>
        </React.Fragment>
    );
}

export default ChangePasswordModal;